import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../admin.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-location-edit',
  standalone: false,
  templateUrl: './location-edit.component.html',
  styleUrls: ['./location-edit.component.css']
})
export class LocationEditComponent implements OnInit {
  isNew = false;
  locationId: number | null = null;
  formData: any = {
    location_type: '', name: '', location_token: '',
    address_line_1: '', address_line_2: '', suburb: '', state: '', country: ''
  };

  constructor(
    private admin: AdminService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.locationId = +idParam;
      this.loadLocation(this.locationId);
    } else {
      this.isNew = true;
    }
  }

  private loadLocation(id: number): void {
    this.admin.getLocation(id).subscribe(l => {
      const loc = l?.data ?? l;
      if (!loc || !loc.id) {
        notify('Location not found', 'error', 2500);
        this.router.navigate(['/admin/locations']);
        return;
      }
      this.formData = {
        location_type: loc.location_type,
        name: loc.name,
        location_token: loc.location_token,
        address_line_1: loc.address_line_1,
        address_line_2: loc.address_line_2,
        suburb: loc.suburb,
        state: loc.state,
        country: loc.country
      };
    });
  }

  save(): void {
    if (this.isNew) {
      this.admin.createLocation(this.formData).subscribe(() => {
        notify('Location created', 'success', 2000);
        this.router.navigate(['/admin/locations']);
      }, err => notify(err?.error?.message || 'Unable to create location', 'error', 2500));
    } else {
      // location_token is immutable on update (the API doesn't accept it here).
      const payload = { ...this.formData };
      delete payload.location_token;
      this.admin.updateLocation(this.locationId!, payload).subscribe(() => {
        notify('Location updated', 'success', 2000);
        this.router.navigate(['/admin/locations']);
      }, err => notify(err?.error?.message || 'Unable to update location', 'error', 2500));
    }
  }

  cancel(): void {
    this.router.navigate(['/admin/locations']);
  }
}
